export default [
  {
    title: "Patient card",
    to: "/ikp",
    icon: "mdi-view-dashboard",
    group: "",
    subItems: [],
  },
  {
    title: "Tasks",
    to: "/tasks",
    icon: "mdi-checkbox-marked-outline",
    group: "",
    subItems: [],
  },

  {
    title: "Documents",
    to: "/documents",
    icon: "mdi-checkbox-marked-outline",
    group: "",
    subItems: [],
  },
  {
    title: "Other",
    icon: "mdi-checkbox-marked-outline",
    group: "",
    children: [
      {
        title: "Tasks Results",
        to: "tasks-results",
        icon: "mdi-checkbox-marked-outline",
      },
      {
        title: "Inspection",
        to: "inspection",
        icon: "mdi-checkbox-marked-outline",
      },

      {
        title: "Appointment",
        to: "appointment",
        icon: "mdi-home",
      },

      {
        title: "Online consultations",
        to: "online-consultations",
        icon: "mdi-home",
      },

      {
        title: "Conducting research",
        to: "research",
        icon: "mdi-checkbox-marked-outline",
      },
      //   {
      //     title: "Laboratory research",
      //     to: "laboratory-research",
      //     icon: "mdi-checkbox-marked-outline",
      //   },

      //   {
      //     title: "Allergies",
      //     to: "allergy",
      //     icon: "mdi-checkbox-marked-outline",
      //   },

      {
        title: "Unspecified diagnoses",
        to: "diagnosis",
        icon: "mdi-checkbox-marked-outline",
      },

      //   {
      //     title: "Diseases",
      //     to: "diseases",
      //     icon: "mdi-checkbox-marked-outline",
      //   },

      //   {
      //     title: "Medicines",
      //     to: "drugs",
      //     icon: "mdi-home",
      //   },

      //   {
      //     title: "Parameters",
      //     to: "parameters",
      //     icon: "mdi-checkbox-marked-outline",
      //   },

      //   {
      //     title: "Previous appeal",
      //     to: "previous-appeal",
      //     icon: "mdi-checkbox-marked-outline",
      //   },

      //   {
      //     title: "Calendar",
      //     to: "calendar",
      //     icon: "mdi-checkbox-marked-outline",
      //   },

      {
        title: "Interview",
        to: "interview",
        icon: "mdi-checkbox-marked-outline",
      },

      {
        title: "Group conclusion",
        to: "group-conclusion",
        icon: "mdi-checkbox-marked-outline",
      },
      {
        title: "Agreements",
        to: "agreements",
        icon: "mdi-checkbox-marked-outline",
      },
    ],
  },

  // Для примера формирования под меню
  /*{
            title: 'Пример под-меню',
            to: '/page',
            icon: 'mdi-history',
            group: 'pages',
            children: [
                {
                    title: 'Под меню 1',
                    to: '/',
                    icon: '',
                },
            ],
        }*/
];
